<template>
  <div id="app">
    <VueHeadful
      :title="title"
      :description="description"
    />

    <template>
      <slot />

      <Spinner
        v-show="loading"
        :loading="loading"
      />
    </template>
  </div>
</template>

<script>
import { sync } from 'vuex-pathify';
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters([
      'loading', //
    ]),

    ...sync([
      'lang.lang', //
      'meta.title',
      'meta.description',
    ]),
  },

  mounted() {
    setTimeout(() => {
      this.$store.dispatch('lang/switchLang', this.lang);
    }, 100);
  },
};
</script>

<style>
@import '~vue-plyr/dist/vue-plyr.css';
</style>
